import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';
import { getIsNewDeal } from 'store/dealManagement/selectors/getIsNewDeal';

export const getLineLevelCpmSettings = createSelector(
  (state: Store) => state.dealConfig,
  getIsNewDeal,
  (state: Store) => state.dealManagement.programmatic?.enableLineLevelTrading,
  (dealConfig, isNewDeal, enableLineLevelTradingCampaignResponse) => {
    const enableLineLevelTradingPublisherConfig = dealConfig.enableLineLevelTrading;

    if (!enableLineLevelTradingPublisherConfig) {
      if (!isNewDeal && enableLineLevelTradingCampaignResponse) {
        return { isLineLevelCpmVisible: true, isLineLevelCpmEditable: true };
      }

      return { isLineLevelCpmVisible: false, isLineLevelCpmEditable: false };
    }

    if (enableLineLevelTradingPublisherConfig) {
      if (!isNewDeal && !enableLineLevelTradingCampaignResponse) {
        return { isLineLevelCpmVisible: true, isLineLevelCpmEditable: false };
      }

      return { isLineLevelCpmVisible: true, isLineLevelCpmEditable: true };
    }

    return { isLineLevelCpmVisible: false, isLineLevelCpmEditable: false };
  },
);
